module.exports = __webpack_public_path__ + "static/online-shop-1-184d80e664ae84b8a026c45b4e74909b.png";